import * as action from "./actions";

export const savePurchase = purchaseBundle => {
  return {
    type: action.SAVE_PURCHASE,
    payload: purchaseBundle
  };
};

export const saveSuccess = purchaseBundle => {
  return {
    type: action.SAVE_SUCCESS,
    payload: purchaseBundle
  };
};

const ACTION_HANDLERS = {
  [action.SAVE_PURCHASE]: (state, action) => {
    return { ...state };
  },
  [action.SAVE_SUCCESS]: (state, action) => {
    return { ...state, ...action.payload };
  }
};

let defaultState = {
  purchaseStatus: {
    status: 0
  }
};

export const reducer = (state = defaultState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
